module.exports = __webpack_public_path__ + "img/a2.941e9a13.png";